module.exports = {"370281001":"阜安街道","370281002":"中云街道","370281004":"三里河街道","370281006":"九龙街道","370281007":"胶东街道","370281008":"胶北街道","370281100":"胶莱镇","370281102":"李哥庄镇","370281105":"铺集镇","370281108":"里岔镇","370281110":"胶西镇","370281111":"洋河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370281.json
// module id = 1266
// module chunks = 0